import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react'
import AnimateHeight from 'react-animate-height'
import CustomAlert from '../../../Components/Alert'
import fetchApiError from '../../../Helpers/fetchApiError'
import { useForm } from '../../../Hooks/useForm'
import TrackingService from '../../../Services/Tracking'
import './styles.scss'

const Tracker = ({ setTrackItResult }) => {
  const { form, onChange, reset } = useForm({
    trackingNumber: '',
    loading: false,
    error: null,
  })

  useEffect(() => {
    return reset
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getDetails = async (num) => {
    onChange('loading', true)
    onChange('error', null)

    try {
      const res = await TrackingService.get_by_tracking_number(num)
      setTrackItResult(res.data.data)
    } catch (error) {
      setTrackItResult(null)
      onChange('error', fetchApiError(error))
    }

    onChange('loading', false)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    getDetails(form.trackingNumber)
  }

  return (
    <div className="tracker">
      <div className="tracker__icon">
        <img src="/favicon.png" alt="Farze Global Logistics" />
      </div>

      <h2 className="tracker__heading">Track Your Shipment</h2>
      <p className="tracker__sub">
        Enter your tracking number below to get real-time updates on your shipment.
      </p>

      <form onSubmit={handleSubmit} className="tracker__form">
        <div className="tracker__input-row">
          <div className="tracker__input-wrap">
            <FontAwesomeIcon className="tracker__input-icon" icon={solid('magnifying-glass')} />
            <input
              type="text"
              placeholder="Enter tracking number"
              value={form.trackingNumber}
              onChange={(e) => onChange('trackingNumber', e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="tracker__btn"
            disabled={form.loading || !form.trackingNumber.trim()}
          >
            {form.loading ? (
              <FontAwesomeIcon icon={solid('circle-notch')} spin />
            ) : (
              'Track'
            )}
          </button>
        </div>

        <AnimateHeight duration={300} height={form.error ? 'auto' : 0}>
          <div className="tracker__error">
            <FontAwesomeIcon icon={solid('circle-exclamation')} />
            {form.error}
          </div>
        </AnimateHeight>
      </form>

      <p className="tracker__hint">
        <FontAwesomeIcon icon={solid('circle-info')} />
        Your tracking number was provided in your shipment confirmation.
      </p>
    </div>
  )
}

export default Tracker
